'use strict';

import { randomString } from './string'

exports.__esModule = true;

var SUCCESS_SUFFIX = "_SUCCESS"
var PROGRESS_SUFFIX = "_PROGRESS"
var FAIL_SUFFIX = "_FAIL"

function makeDataProviderAction(type, payload) {
  return { type, payload }
}

function createDataProviderMiddleware() {

  let transactions = {}
  function dataprovider(_ref) {
    var dispatch = _ref.dispatch
    var getState = _ref.getState
    if (dataprovider.verbose) console.log("dataprovider.factory")
    return function (next) {
      return function (action) {
         if(dataprovider.trigger.hasOwnProperty(action.type)) {
           if (dataprovider.verbose) console.log("dataprovider.trigger", action.type)
           var tasks = dataprovider.trigger[action.type]
           for(var i=0; i<tasks.length; i++) {
             let task = tasks[i]
             let args = (action.payload instanceof Array)?action.payload:[action.payload]
             if (task.transform) {
               args = tasks[i].transform(args)
             }
             const transactionId = randomString()
             action.transactionId = transactionId
             if (typeof dataprovider.fetch === "function") dataprovider.fetch(action, dispatch, getState)
             let call = task.callback.apply(null, args)
             transactions[action.transactionId] = call
             if(task.success) call.then((result) => {
               if (dataprovider.verbose) console.log("task.success", result)
               delete transactions[action.transactionId]
               if (typeof dataprovider.success === "function")  dataprovider.success(result, action, dispatch, getState)
               if(typeof task.success === "function") {
                 dispatch(task.success(result, action))
               } else {
                 dispatch({ type: task.success, transactionId, payload: result, context: action })
               }
             })
             if(task.progress) call.progress((event) => {
               if (dataprovider.verbose) console.log("task.progress", event)
               if (typeof dataprovider.progress === "function")  dataprovider.progress(event, action, dispatch, getState)
               if(typeof task.progress === "function") {
                 dispatch(task.progress(event, action))
               } else {
                 dispatch({ type: task.progress, transactionId, payload: event, context: action })
               }
             })
             if(task.fail) call.catch((error) => {
               if (dataprovider.verbose) console.log("task.fail", error)
               delete transactions[action.transactionId]
               if (typeof dataprovider.fail === "function")  dataprovider.fail(error, action, dispatch, getState)
               if (typeof task.fail === "function") {
                 dispatch(task.fail(error, action))
               } else {
                 dispatch({ type: task.fail, transactionId, payload: error, context: action })
               }
             })

           }
         }
         return next(action)
      }
    }
  }
  dataprovider.verbose = false
  dataprovider.trigger = {}
  dataprovider.fetch = null
  dataprovider.fail = null
  dataprovider.progress = null
  dataprovider.success = null
  dataprovider.bind = function(action, callback, opts = {}) {
    if (dataprovider.verbose) console.log("addTrigger", action, callback, opts)
    if (!dataprovider.trigger.hasOwnProperty(action)) {
      dataprovider.trigger[action] = []
    }
    var data = {callback:callback}
    if (opts.transform) data.transform = opts.transform
    if (opts.success) data.success = opts.success
    if (opts.progress) data.progress = opts.progress
    if (opts.fail) data.fail = opts.fail
    if (opts.implicit !== false) {
      if (!data.success) data.success = action + SUCCESS_SUFFIX
      if (!data.progress) data.progress = action + PROGRESS_SUFFIX
      if (!data.fail) data.fail = action + FAIL_SUFFIX
    }
    dataprovider.trigger[action].push(data)
  }

  dataprovider.cancel = function(transactionId) {
    if (transactions.hasOwnProperty(transactionId)) {
      transactions[transactionId].cancel()
      delete transactions[transactionId]
    }
  }
  return dataprovider
}

exports['SUCCESS_SUFFIX'] = SUCCESS_SUFFIX
exports['PROGRESS_SUFFIX'] = PROGRESS_SUFFIX
exports['FAIL_SUFFIX'] = FAIL_SUFFIX
exports['default'] = createDataProviderMiddleware;



// WEBPACK FOOTER //
// ./src/app/util/dataprovider.js